PageApp.Ent.BasicEntity = Backbone.Model.extend({})
